var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmDialog',{attrs:{"show":_vm.show,"title":_vm.$t('unsavedChanges'),"message":_vm.$t('unsavedChangesDialog')},on:{"confirm":function($event){return _vm.$emit('confirm')},"cancel":function($event){return _vm.$emit('cancel')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }